<template>

    <v-layout row>

      <v-flex xs12 sm12 md12 lg12>
        <div class="d-flex flex-row pt-6 pl-6">
          <img :src="logo" alt="PinPoint Logo">
        </div>
      </v-flex>

      <v-flex xs12 sm12 md12 lg12>
        <div class="d-flex flex-row pt-3 pl-6">
          <h1>Welcome To Pinpoint Systems</h1>
        </div>
      </v-flex>

    </v-layout>

</template>

<script>
import PinPointLogo from "../../assets/PinPointLogo.png"

export default {
  name: 'home',
  data: function () {
    return {
        logo: PinPointLogo
    }
  }
}
</script>

<style scoped>


</style>
